export const LicenseDataSummaryMockData = [
  {
    id: '821969d5-1c4f-4ed8-a56d-4d9b9a9f656e',
    toolCode: '1234',
    deviceType: 'GLC',
    fromDate: '2023-06-15T00:00:00-04:00',
    untilDate: '2023-06-29T17:06:39.648-04:00',
    createdOn: '2023-06-16T17:06:43.5073342-04:00',
    createdBy: 'Mock License Creator',
    customer: 'Mock License Customer',
    project: 'Mock License Project',
    organizationName: 'Mock License Organization Name',
    organizationId: 'f24a232a-3034-4748-1137-08da025277fe',
    signOffPending: false,
    unlimited: false,
  },
] as any[];
